const { get } = require('lodash');

export const getInfluencerId = (state) => get(state?.login, 'userInfo.influencer_id');

export const getUserId = (state) => get(state?.login, 'userInfo.userId');
